import { type ForwardedRef, type MutableRefObject, type RefObject, useImperativeHandle, useRef } from "react";

export function useDOMRef<T extends HTMLElement>(
  ref: RefObject<T> | ForwardedRef<T> | null | undefined,
): MutableRefObject<T | null> {
  type U = T | null;

  const domRef = useRef<T>(null);
  useImperativeHandle<U, U>(ref, () => domRef.current);
  return domRef;
}
